import React, {useEffect} from 'react';
import CdpAux from '../CdpAux';
import './Menu.css';
import ProfileBadge from '../Profile/ProfileBadge';
import MenuButton from './MenuButton';

import TagManager from 'react-gtm-module';
// Page specific GTM params.
const tagManagerArgs = {
    dataLayer: {
        page: 'landing',
        event:'spa-pageview'
    }
}

// Main home page menu component. Contains the buttons as links to the pages.
const Menu = (props) => {
    useEffect(() =>{
        TagManager.dataLayer(tagManagerArgs)
    }, [])
    props.setPage('home');

    const pages = [
        {link:'my-profile', label:'My Profile'},
        {link:'my-retail', label:'My Co-ops'},
        {link:'my-preferences', label:'My Email Preferences'}   
    ]
    const menuButtons = pages.map((b) =>
        <MenuButton 
            setPage={props.setPage}
            link={b.link}
            key={b.link}
            label={b.label}
        />
    )
    return (
        <CdpAux className="container">
            <ProfileBadge customer={props.customer} />
            {menuButtons}
            <div className="buttons">
                <button 
                    type="button" 
                    className="cancel btn secondary" 
                    onClick={()=>props.instance.logout()}
                    aria-label="Sign Out"
                >Sign Out</button>
            </div>
        </CdpAux>
    );
}

export default Menu;